module.exports = __webpack_public_path__ + "static/media/icon-fievre.7caae55d.svg";